import { useMemo } from "react";
import { useAppSelector } from "@/hooks/redux";

import { createSelector } from "@reduxjs/toolkit";

import { getDialogStack } from "../../lib/selectors";

import type { RegisteredDialog } from "../../dialog-registry";

const selectOpenDialogIds = createSelector([getDialogStack], stack => stack.filter(x => x.show).map(x => x.id));

export function useDialogOpen(id: RegisteredDialog) {
  const openDialogIds = useAppSelector(selectOpenDialogIds);

  return useMemo(() => openDialogIds.includes(id), [openDialogIds, id]);
}
